<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="公文管理" name="first">
				<div class="k-page-common">
					<!-- <div class="k-common-header">
					<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
						<el-form :inline="true" :model="searchForm" size="mini">
							<el-form-item label="公司名称">
								<el-input v-model="searchForm.company_name" placeholder="请填写公司名称" clearable></el-input>
							</el-form-item>
							<el-form-item label="业务类型">
								<el-select v-model="searchForm.type" placeholder="请选择" clearable style="width: 100%;">
									<el-option label="供应商" :value="1"></el-option>
									<el-option label="客户" :value="2"></el-option>
									<el-option label="平台" :value="3"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="状态">
								<el-select v-model="searchForm.pay_type" placeholder="请选择" clearable style="width: 100%;">
									<el-option label="待提交" :value="1"></el-option>
									<el-option label="待审核" :value="2"></el-option>
									<el-option label="被驳回" :value="3"></el-option>
									<el-option label="正常" :value="4"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
								<el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div> -->
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;"
								v-if="$parent.$parent.isAuthAction('admin/news/message/addnotice')">
								<div>
									<el-button type="primary" size="mini" @click="addNewsOpen"
										v-if="$parent.$parent.isAuthAction('admin/news/message/addnotice')">添加公文</el-button>
								</div>
							</div>
							<div class="k-table-con">
								<el-table v-loading="loading" :data="tableData.data" style="width: 100%" row-key="id" border stripe
									ref="table" highlight-current-row :height="tableHeight">
									<el-table-column fixed prop="id" label="ID" align="center" width="50">
									</el-table-column>
									<el-table-column fixed prop="departments" label="查看范围" :show-overflow-tooltip="true" width="200">
									</el-table-column>
									<el-table-column prop="type_txt" label="分类" min-width="120">
									</el-table-column>
									<el-table-column prop="title" label="标题" min-width="200">
										<template slot-scope="scope">
											<el-link type="primary" style="font-size: 12px; text-decoration: underline;" :underline="false"
												@click="detail(scope.row)" target="_blank">{{ scope.row.title }}</el-link>
										</template>
									</el-table-column>
									<el-table-column prop="uid_txt" label="添加人" width="100">
									</el-table-column>
									<el-table-column prop="create_time" label="添加时间" min-width="180">
									</el-table-column>
									<el-table-column prop="is_read_txt" label="阅读状态" min-width="100">
									</el-table-column>
									<el-table-column prop="is_force_read_txt" label="是否强制阅读" min-width="120">
									</el-table-column>
									<el-table-column prop="end_force_read" label="强制阅读截止日期" width="200">
									</el-table-column>
									<el-table-column fixed="right" prop="is_replace_txt" label="状态" align="center" width="100">
										<template slot-scope="scope">
											<span style="font-weight: bold;">{{ scope.row.is_replace_txt }}</span>
										</template>
									</el-table-column>
									<el-table-column fixed="right" label="操作"
										v-if="$parent.$parent.isAuthAction('admin/news/message/editnotice') || $parent.$parent.isAuthAction('admin/news/message/replacenotice') || $parent.$parent.isAuthAction('admin/news/message/replacenotice')"
										width="160">
										<template slot-scope="scope">
											<template>
												<el-button @click="handleTableEditOpen(scope.row)" type="text"
													:disabled="!(scope.row.is_replace == 2 && scope.row.is_edit == 1)" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/news/message/editnotice')">编辑</el-button>
												<el-button @click="handleRelease(scope.row)" type="text" :size="size"
													:disabled="!(scope.row.is_replace == 2 && scope.row.is_edit == 1)"
													v-if="$parent.$parent.isAuthAction('admin/news/message/replacenotice')">发布</el-button>
												<el-button @click="handleRelease(scope.row)" type="text" :size="size"
													:disabled="!(scope.row.is_replace == 1 && scope.row.is_edit == 1)" class="c-danger"
													v-if="$parent.$parent.isAuthAction('admin/news/message/replacenotice')">取消发布</el-button>
											</template>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--添加公文-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" v-loading="loading"
			:close-on-press-escape='false' :wrapperClosable='false' size="80%">
			<div class="drawer-header">
				<div class="header-title">
					<span>添加公文</span>
					<i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
				</div>
			</div>
			<div class="drawer-content">
				<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="140px">
					<div>
						<el-form-item label="公文类型" key="type" prop="type">
							<el-select v-model="addForm.type" placeholder="请选择" clearable style="width: 100%;">
								<el-option label="促销活动" :value="1"></el-option>
								<el-option label="公司通知" :value="2"></el-option>
								<el-option label="制度政策" :value="3"></el-option>
								<el-option label="公司动态" :value="4"></el-option>
								<el-option label="系统公告" :value="5"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="标题" prop="title">
							<el-input v-model="addForm.title" placeholder="请填写公文标题" clearable></el-input>
						</el-form-item>
						<el-form-item label="部门" prop="department_ids">
							<el-cascader style="width: 100%;" placeholder="请搜索部门" v-model="addForm.department_ids"
								:options="options.department_ids_options"
								:props="{ multiple: true, label: 'department_name', value: 'id', checkStrictly: true }"
								filterable></el-cascader>
						</el-form-item>
						<el-form-item label="是否强制阅读" prop="is_force_read" key="is_force_read">
							<el-radio-group v-model="addForm.is_force_read">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="2">否</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="强制阅读截止时间" prop="end_force_read" v-if="addForm.is_force_read == 1">
							<div style="width: 220px; display: inline-block;">
								<el-date-picker v-model="addForm.end_force_read" type="date" format="yyyy-MM-dd"
									value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择日期">
								</el-date-picker>
							</div>
						</el-form-item>
						<el-form-item label="强制阅读时间" prop="read_time" v-if="addForm.is_force_read == 1">
							<div style="width: 220px; display: inline-block;"><el-input v-model.number="addForm.read_time"
									placeholder="请填写强制阅读时间" clearable></el-input></div>
							<span style="color: #606266; margin-left: 10px;">秒</span>
						</el-form-item>
						<el-form-item label="是否发布" prop="is_replace" key="is_replace">
							<el-radio-group v-model="addForm.is_replace">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="2">否</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="内容" prop="content">
							<template>
								<div style="border: 1px solid #DCDFE6;">
									<Toolbar style="border-bottom: 1px solid #DCDFE6" :editor="editor" :defaultConfig="toolbarConfig"
										:mode="mode" />
									<Editor style="height: 500px; overflow-y: hidden;" v-model="addForm.content"
										:defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
								</div>
							</template>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button type="primary" @click="addNews()" :size='size'>提交</el-button>
				<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
			</div>
		</el-drawer>
		<!--编辑发票信息-->
		<el-drawer custom-class="k-drawer" :visible.sync="editFormVisiable" direction="rtl" v-loading="d_loading"
			@opened="openedDraw" :close-on-press-escape='false' :wrapperClosable='false' size="60%">
			<div class="drawer-header">
				<div class="header-title">
					<span>编辑公文</span>
					<i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
				</div>
			</div>
			<div class="drawer-content">
				<el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="140px">
					<div>
						<el-form-item label="公文类型" key="type" prop="type">
							<el-select v-model="editForm.type" placeholder="请选择" clearable style="width: 100%;">
								<el-option label="促销活动" :value="1"></el-option>
								<el-option label="公司通知" :value="2"></el-option>
								<el-option label="制度政策" :value="3"></el-option>
								<el-option label="公司动态" :value="4"></el-option>
								<el-option label="系统公告" :value="5"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="标题" prop="title">
							<el-input v-model="editForm.title" placeholder="请填写公文标题" clearable></el-input>
						</el-form-item>
						<el-form-item label="部门" prop="department_ids">
							<el-cascader style="width: 100%;" placeholder="请搜索部门" v-model="editForm.department_ids"
								:options="options.department_ids_options"
								:props="{ multiple: true, label: 'department_name', value: 'id', checkStrictly: true }"
								filterable></el-cascader>
						</el-form-item>
						<el-form-item label="是否强制阅读" prop="is_force_read" key="is_force_read">
							<el-radio-group v-model="editForm.is_force_read">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="2">否</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="强制阅读截止时间" prop="end_force_read" v-if="editForm.is_force_read == 1">
							<div style="width: 220px; display: inline-block;">
								<el-date-picker v-model="editForm.end_force_read" type="date" format="yyyy-MM-dd"
									value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择日期">
								</el-date-picker>
							</div>
						</el-form-item>
						<el-form-item label="强制阅读时间" prop="read_time" v-if="editForm.is_force_read == 1">
							<div style="width: 220px; display: inline-block;"><el-input v-model.number="editForm.read_time"
									placeholder="请填写强制阅读时间" clearable></el-input></div>
							<span style="color: #606266; margin-left: 10px;">秒</span>
						</el-form-item>
						<el-form-item label="是否发布" prop="is_replace" key="is_replace">
							<el-radio-group v-model="editForm.is_replace">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="2">否</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="内容" prop="content">
							<template>
								<div style="border: 1px solid #DCDFE6;">
									<Toolbar style="border-bottom: 1px solid #DCDFE6" :editor="editor" :defaultConfig="toolbarConfig"
										:mode="mode" />
									<Editor style="height: 500px; overflow-y: hidden;" v-model="editForm.content"
										:defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
								</div>
							</template>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button type="primary" @click="handleTableEdit()" :size='size'>提交</el-button>
				<el-button :size='size' @click="editFormVisiable = false">取消</el-button>
			</div>
		</el-drawer>
		<el-dialog :visible.sync="dialogVisibleImg">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
	props: ['info'],
	components: { Editor, Toolbar },
	data () {
		return {
			editor: null,
			html: '<p>hello</p>',
			toolbarConfig: {
				// 排除的不要的工具
				excludeKeys: ['emotion', 'uploadVideo', 'editVideoSize', 'group-video', 'fullScreen']
			},
			editorConfig: {
				// 配置图片上传
				MENU_CONF: {
					uploadImage: {
						// server: '/admin/customers/customer/noticeimage', // 替换为你的服务器地址
						headers: {
							'Content-Type': 'multipart/form-data',
						}, // 自定义请求头
						fieldName: 'file', // 文件域的名称
						// maxFileSize: 1 * 1024 * 1024, // 图片大小不超过 2MB
						timeout: 1 * 60 * 1000, // 超时时间 3 分钟
						// base64LimitSize: 1*1024*1024, // 5M
						customUpload: this.customUpload,

					},
				}
			},
			mode: 'default', // or 'simple'
			pickerOptions: {
				disabledDate (time) {
					// 获取今天的日期
					const today = new Date();
					today.setHours(0, 0, 0, 0); // 设置时间为00:00:00:000
					return time.getTime() < today.getTime(); // 禁用今天之前的日期
				}
			},
			dialogImageUrl: '',
			dialogVisibleImg: false,
			addFormVisiable: false,
			editFormVisiable: false,
			loading: false,
			d_loading: false,
			activeName: 'first',
			size: 'mini',
			options: {
				department_ids_options: []
			},
			searchForm: {
				department_name: '',
			},
			resetSearch: {
				department_name: '',
			},
			addForm: {
				type: '',
				title: '',
				content: '',
				is_force_read: 2,
				read_time: '',
				end_force_read: '',
				send_id: '',
				is_replace: 2,
				department_ids: []
			},
			editForm: {
				id: '',
				type: '',
				title: '',
				content: '',
				is_force_read: 2,
				read_time: '',
				end_force_read: '',
				send_id: '',
				is_replace: 2,
				department_ids: []
			},
			rules: {
				addForm: {
					'type': [
						{ required: true, message: '请选择公文类型', trigger: ['change'] }
					],
					'title': [
						{ required: true, message: '请填写公文标题', trigger: ['change', 'blur'] }
					],
					'content': [
						{ required: true, message: '请填写公文内容', trigger: ['blur'] }
					],
					'is_force_read': [
						{ required: true, message: '请选择是否强制阅读', trigger: ['change', 'blur'] }
					],
					'read_time': [
						{ required: true, type: 'number', message: '请填写正确的强制阅读时间', trigger: ['change', 'blur'] }
					],
					'end_force_read': [
						{ required: true, message: '请选择强制阅读截止时间', trigger: ['change', 'blur'] }
					],
					'is_replace': [
						{ required: true, message: '请选择是否发布', trigger: ['change', 'blur'] }
					],
					'department_ids': [
						{ required: true, message: '请选择强制阅读部门', trigger: ['change', 'blur'] }
					]
				},
				editForm: {
					'type': [
						{ required: true, message: '请选择公文类型', trigger: ['change'] }
					],
					'title': [
						{ required: true, message: '请填写公文标题', trigger: ['change', 'blur'] }
					],
					'content': [
						{ required: true, message: '请填写公文内容', trigger: ['blur'] }
					],
					'is_force_read': [
						{ required: true, message: '请选择是否强制阅读', trigger: ['change', 'blur'] }
					],
					'read_time': [
						{ required: true, type: 'number', message: '请填写正确的强制阅读时间', trigger: ['change', 'blur'] }
					],
					'end_force_read': [
						{ required: true, message: '请选择强制阅读截止时间', trigger: ['change', 'blur'] }
					],
					'is_replace': [
						{ required: true, message: '请选择是否发布', trigger: ['change', 'blur'] }
					],
					'department_ids': [
						{ required: true, message: '请选择强制阅读部门', trigger: ['change', 'blur'] }
					]
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
		}
	},
	computed: {
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	mounted: function () {
		this.handleSearch(this.searchForm);
	},
	beforeDestroy () {
		const editor = this.editor
		if (editor == null) return
		editor.destroy() // 组件销毁时，及时销毁编辑器
	},
	methods: {
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		customUpload (file, insertFn) {
			const maxSize = 1 * 1024 * 1024; // 1 MB
			if (file.size > maxSize) {
				this.$message.error('图片大小不能超过 1 MB');
				return;
			}

			const formData = new FormData();
			formData.append('file', file);
			this.$api.post('/admin/news/message/updateImage', formData).then(res => {
				if (res.code == 0) {
					insertFn(res.data)
				}
			})

		},
		onCreated (editor) {
			this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报
		},
		//列表查询
		handleSearch (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/news/message/getnoticelist', param).then(res => {
				if (res.code == 0) {
					this.tableData = res.data;
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		// 添加发票信息弹窗
		addNewsOpen () {
			this.getDepartmentIds()
			this.addForm = {
				type: '',
				title: '',
				content: '',
				is_force_read: 2,
				read_time: '',
				end_force_read: '',
				send_id: '',
				is_replace: 2,
				department_ids: []
			}
			this.addFormVisiable = true;
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
		},
		// 添加公文
		addNews () {
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					let newArray = this.addForm.department_ids.map(subArray => subArray[subArray.length - 1]);
					let newForm = JSON.parse(JSON.stringify(this.addForm))
					newForm.department_ids = newArray
					this.loading = true;
					this.$api.post('/admin/news/message/addnotice', newForm).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '公文添加成功！',
								type: 'success'
							});
							this.addFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		openedDraw () {
			this.$api.get('/admin/news/message/getnoticeinfo', { id: this.editForm.id }).then(res => {
				if (res.code === 0) {
					this.editForm = res.data
					this.getDepartmentIds()
				} else {
					this.$message.error(res.msg);
				}
				this.d_loading = false
			})
		},
		// 打开编辑弹窗
		handleTableEditOpen (row) {
			this.d_loading = true
			this.editFormVisiable = true;
			this.editForm.id = row.id
		},
		// 编辑
		handleTableEdit () {
			this.$refs['editForm'].validate(function (valid) {
				if (valid) {
					let newArray = this.editForm.department_ids.map(subArray => subArray[subArray.length - 1]);
					let newForm = JSON.parse(JSON.stringify(this.editForm))
					newForm.department_ids = newArray
					this.loading = true;
					this.$api.post('/admin/news/message/editnotice', newForm).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch('', this.tableData.page);
							this.$message({
								showClose: true,
								message: '公告修改成功！',
								type: 'success'
							});
							this.editFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		getDepartmentIds (query) {
			query = query ? query : ''
			this.$api.get('/admin/users/user/getDepartmentTree', { 'query': query, type: 1 }).then(res => {
				if (res.code === 0) {
					this.options.department_ids_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		handleRelease (row) {
			this.$api.post('/admin/news/message/replacenotice', { id: row.id }).then(res => {
				if (res.code === 0) {
					this.handleSearch('', this.tableData.page);
					this.$message({
						showClose: true,
						message: res.msg,
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		detail (row) {
			this.$router.push({
				name: 'NewsDetail',
				query: { id: row.id }
			});
		}
	},
}
</script>